<div class="navbar" fxLayoutAlign="center start" [ngClass]="{'navbar-fixed-top' : !navbarFixedTop}">
    <div fxLayout="row" fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
        <mat-toolbar>
            <a [routerLink]="['/']"><img class="logo" src="/assets/img/logo-01.svg" width="65px" alt="Plaza Hogar Logo" /></a>

            <div class="search">
                <mat-form-field appearance="fill">
                    <input matInput [matAutocomplete]="auto" placeholder="Buscar productos, marcas y más..." [(ngModel)]="searchInput" (keydown.enter)="onSearch($event)">
                    <span matSuffix class="jam jam-search" (click)="onSearch($event)"></span>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="separate-line" fxHide.xs></div>

            <!-- Categories  -->
            <button mat-button class="nav-link" fxHide fxShow.xs [matMenuTriggerFor]="matCategories">
                <span class="jam jam-align-justify"></span>
            </button>
            <button mat-button class="nav-link" fxHide.xs [matMenuTriggerFor]="matCategories">Categorías</button>


            <mat-menu #matCategories="matMenu" class="category-navbar">
                <ng-container *ngFor="let category of categories">
                    <ng-container *ngIf="category.childs && category.childs.length > 0">
                        <app-menu-nested-item #menu [items]="category.childs"></app-menu-nested-item>
                        <button mat-menu-item [matMenuTriggerFor]="menu.childMenu" [routerLink]="['/buscar/categoria/'+ category.id +'/' + category.title]">{{category.title}}</button>
                    </ng-container>

                    <button *ngIf="!category.childs || category.childs.length === 0" mat-menu-item [routerLink]="['/buscar/categoria/'+ category.id +'/' + category.title]">{{ category.title }}</button>
                </ng-container>
            </mat-menu>

            <span class="example-spacer"></span>


            <!-- Button Shopping Cart -->
            <a [routerLink]="['/carrito-de-compras']"><button mat-button class="nav-link">
                <span *ngIf="cart.length > 0" matBadge="{{ cart.length }}" matBadgeColor="primary" class="jam jam-shopping-cart" aria-hidden="false" aria-label="Shopping Cart icon"></span>
                <span *ngIf="cart.length == 0" class="jam jam-shopping-cart" aria-hidden="false" aria-label="Shopping Cart icon"></span>
            </button></a>

            <!-- Button Login -->
            <button *ngIf="currentUser.email == '' || currentUser.email == undefined" mat-button class="nav-link" fxHide fxShow.xs [matMenuTriggerFor]="login">
                <span class="jam jam-user-circle"></span>
            </button>

            <button *ngIf="currentUser.email == '' || currentUser.email == undefined" mat-button class="nav-link" fxHide.xs [matMenuTriggerFor]="login">Ingresá</button>
            <mat-menu #login="matMenu" [hasBackdrop]="false" [overlapTrigger]="false" class="login-navbar">
                <app-login (click)="stopPropagation($event)"></app-login>
            </mat-menu>


            <!-- Button Account -->
            <button *ngIf="currentUser.email != '' && currentUser.email != undefined" fxShow.lt-md mat-button class="nav-link" [matMenuTriggerFor]="account">
                <span class="jam jam-user-circle"></span>
                <span fxHide.xs>{{ currentUser.firstname }}</span>
                <span class="jam jam-chevron-down"></span>
            </button>

                <mat-menu #account="matMenu" class="account-navbar">
                    <mat-action-list>
                        <a *ngIf="currentUser.email != '' && currentUser.email != undefined" [routerLink]="['/mi-cuenta']"><mat-list-item routerLinkActive="active"><span class="jam jam-shopping-bag"></span> Mis Compras </mat-list-item></a>
                        <!--<mat-list-item [routerLink]="['/mi-cuenta']" routerLinkActive="active"><span class="jam jam-heart"></span> Favoritos </mat-list-item>-->
                        <mat-list-item *ngIf="currentUser.email != '' && currentUser.email != undefined" (click)="onLogout()"><span class="jam jam-log-out"></span> Salir </mat-list-item>

                        <!-- user no logged / only version Mobile -->
                        <!-- <mat-list-item fxHide fxShow.lt-md [matMenuTriggerFor]="register"><span class="jam jam-user-plus"></span> Registrarse </mat-list-item> -->
                    </mat-action-list>
                </mat-menu>


            <!-- Button Menu -->
            
            <!-- <button mat-button fxHide class="nav-link navbar-menu-active" (click)="jamClose = !jamClose" (click)="menuOpen = !menuOpen" (click)="navbarFixedTop = !navbarFixedTop"><span [ngClass]="{'jam-close' : jamClose}" class="jam jam-close jam-menu" aria-hidden="false" aria-label="Menu icon"></span></button> -->
        </mat-toolbar>
    </div>
</div>
